import {css} from '@emotion/css';
import {useMemo} from 'react';

import {useWolfTheme} from '../../contexts';

const useStyles = () => {
    const theme = useWolfTheme();

    // Icon size + padding;
    // eslint-disable-next-line i18next/no-literal-string
    const toggleHeight = `calc(24px + (6px * 2))`;

    return useMemo(
        () => ({
            left: css({
                display: 'flex',
                alignItems: 'center',
                height: toggleHeight,
                gap: theme.orbitalFour,
            }),
            header: css({
                backgroundColor: theme.palette.background.container,
                padding: `${theme.orbitalThree} ${theme.orbitalFour}`,
                color: theme.palette.foreground.default,
                display: 'flex',
                justifyContent: 'space-between',
                border: `1px solid ${theme.palette.stroke.default}`,
            }),

            toggle: css({
                height: toggleHeight,
            }),
        }),
        [
            theme.orbitalFour,
            theme.orbitalThree,
            theme.palette.background.container,
            theme.palette.foreground.default,
            theme.palette.stroke.default,
            toggleHeight,
        ]
    );
};

export default useStyles;
